module.exports = __webpack_public_path__ + "static/media/2.61bca5fc.png";